import {Button} from 'antd';
import React from 'react';
import {CloseCircleOutlined} from '@ant-design/icons';

export const RemoveFollowUpButton = ({onClick}) => {
  return (
    <Button type="link" style={{color: '#d22528', padding: 0}} onClick={onClick}>
      <CloseCircleOutlined />
    </Button>
  );
};
